<template lang="pug">
  #user-agreements.body: .body-inner
    Simplebar(data-simplebar-auto-hide="false" class="body-simplebar")
      .content(v-html="getUserAgreements")
</template>

<script>
import store from '@/store'
import Simplebar from 'simplebar-vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'UserAgreements',
  // Components ----------------------------------------------------------------
  components: {
    Simplebar
  },
  // Before route enter ------------------------------------------------- [Hook]
  async beforeRouteEnter (to, from, next) {
    if (!store.state.moduleUser.terms) {
      const { status, errors } = await store.dispatch('moduleUser/fetchTerms')
      if (status) next()
      else store.commit('moduleWizard/SET_NAV_FIELD', { f: 'errorTextNext', v: errors.global[0] })
    } else {
      next()
    }
  },
  // Created ------------------------------------------------------------ [Hook]
  created () {
    this.SET_CURRENT_VIEW({ vm: this })
  },
  // Computed ------------------------------------------------------------------
  computed: {
    // Vuex map getters of the Wizard SM
    ...mapGetters('moduleWizard', [
      'getCurrentStepName'
    ]),
    // Vuex map getters of the User SM
    ...mapGetters('moduleUser', [
      'getUserAgreements'
    ])
  },
  // Methods -------------------------------------------------------------------
  methods: {
    // Vuex map mutations of the Wizard SM
    ...mapMutations('moduleWizard', [
      'SET_CURRENT_VIEW'
    ]),
    // Vuex map actions of the Security SM
    ...mapActions('moduleSecurity', [
      'sendMessage'
    ]),
    // Self back validator
    async backSelf () {
      //
    },
    // Self next validator
    async nextSelf () {
      this.sendMessage({ e: 'TermsOfUseComplete' })
      this.$router.push({ name: this.getCurrentStepName }) // just go back
      return false
    }
  }
}
</script>
